import React, { Component } from 'react';
import { getTimehash as generateTimeHash } from "@gerenciatd/next13.utils.page.get-time-hash";
import isFrontApp from '@gerenciatd/next13.utils.common.is-front-app';

let instance = null;

class VarBox extends Component {
    static initialize() {
        if (!instance) {
            instance = new VarBox();
            instance.time = generateTimeHash();
        }
    }

    static getTimeHash() {
        VarBox.initialize();
        if (isFrontApp()) {
            const timeHashMeta = document.querySelector('meta[id="var-box-time-hash"]');
            if(timeHashMeta){
                return timeHashMeta.getAttribute("content");
            }
            return "";
        }
        return instance.time;
    }

    render() {
        VarBox.initialize();
        return (
            <>
                <meta id="var-box-time-hash" content={VarBox.getTimeHash()} />
            </>
        );
    }
}

export default VarBox;
